import { requestConstantsMaker } from '../helper';

export const GET_ALL_APPLICATION = requestConstantsMaker('GET_ALL_APPLICATION');
export const GET_APPLICATION = requestConstantsMaker('GET_APPLICATION');
export const CREATE_APPLICATION = requestConstantsMaker('CREATE_APPLICATION');